module.exports = __webpack_public_path__ + "static/media/castles_win.716cbdc0.png";